/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice } from '@reduxjs/toolkit'
import { Store } from 'builder/modules/store'
import { VirtualCoachState } from 'builder/features/virtualCoach/types'
import { DEFAULT_STATE } from './constants'

const initialState: VirtualCoachState = {
  messages: DEFAULT_STATE,
  loading: false,
  error: null,
}

export const selectors = {
  messages: (state: Store) => state.virtualCoach.messages,
  loading: (state: Store) => state.virtualCoach.loading,
  error: (state: Store) => state.virtualCoach.error,
}

const { reducer, actions } = createSlice({
  name: 'virtualCoach',
  initialState,
  reducers: {
    sendMessage: (state, action) => {
      state.loading = true
      state.error = null
    },
    addUserMessage: (state, action) => {
      state.messages.push({ role: 'user', content: action.payload })
    },
    receiveMessage: (state, action) => {
      const { payload } = action
      state.messages.push({
        role: 'assistant',
        content: payload.response,
        urlLinks: payload.urlLinks,
      })
      state.loading = false
    },
    openChatBot: state => {},
    hydrateMessages: (state, action) => {
      state.messages = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
      state.loading = false
    },
    resetChat: state => {
      state.messages = []
      state.loading = false
      state.error = null
    },
  },
})

export { reducer, actions }
